<template>
  <div>
    <p class="title">申请人信息</p>
    <van-cell-group>
      <van-field required readonly label="姓名" :value="userInfo.xm" readonly input-align="right" />
      <van-field required v-model="userInfo.gmsfhm" clearable readonly label="公民身份证号" placeholder="请输入身份证号"
        input-align="right" />
      <van-field required label="联系电话" v-model="userInfo.lxdh" readonly input-align="right" />
      <van-field required readonly clickable label="性别:" input-align="right" is-link :value="userInfo.Sex"
        placeholder="请选择" @click="userInfo.showPickerSex = true" />
      <van-popup v-model="userInfo.showPickerSex" position="bottom">
        <van-picker show-toolbar :columns="columnsSex" value-key="title" @cancel="showPickerSex = false"
          @confirm="onConfirmSex" />
      </van-popup>
      <van-field v-model="userInfo.Province" label="户口所在地:" placeholder="请选择省份" is-link required readonly
        input-align="right" @click="userInfo.showProvince = true" />
      <van-popup v-model="userInfo.showProvince" position="bottom">
        <van-picker :columns="provinceList" show-toolbar value-key="title" @cancel="userInfo.showProvince = false"
          @confirm="onConfirmProvince" />
      </van-popup>
      <van-field v-model="userInfo.City" placeholder="请选择市区" is-link readonly required input-align="right"
        @click="userInfo.showCity = true" v-if="userInfo.CityShow" />
      <van-popup v-model="userInfo.showCity" position="bottom">
        <van-picker :columns="cityList" show-toolbar value-key="title" @cancel="userInfo.showCity = false"
          @confirm="onConfirmCity" />
      </van-popup>
      <van-field v-model="userInfo.Area" placeholder="请选择区县" is-link readonly required input-align="right"
        @click="userInfo.showArea = true" v-if="userInfo.AreaShow" />
      <van-popup v-model="userInfo.showArea" position="bottom">
        <van-picker :columns="areaList" show-toolbar value-key="title" @cancel="userInfo.showArea = false"
          @confirm="onConfirmArea" />
      </van-popup>

      <van-field input-align="right" label="申请事由:" type="textarea" required v-model="userInfo.sqrsqsy" placeholder="就业、留学、出国、移民等其他日常事务" rows="1"
        autosize clearable  maxlength="15"/>

      <van-field
          readonly
          required
          clickable
          is-link
          input-align="right"
          name="picker"
          :value="userInfo.lqfsTitle"
          label="领取方式"
          placeholder="请选择领取方式"
          @click="showPicker = true"
      />
      <van-popup v-model="showPicker" position="bottom">
        <van-picker
            show-toolbar
            value-key="title"
            :columns="columns"
            @confirm="onConfirm"
            @cancel="showPicker = false"
        />
      </van-popup>
      <template v-if="userInfo.lqfs === '1'">
        <van-field v-model="userInfo.YjProvince" label="邮寄地址:" placeholder="请选择省份" is-link required readonly
                   input-align="right" @click="userInfo.showYjProvince = true" />
        <van-popup v-model="userInfo.showYjProvince" position="bottom">
          <van-picker :columns="provinceList" :default-index="8" show-toolbar value-key="title" @cancel="userInfo.showYjProvince = false"
                      @confirm="onConfirmYjProvince" />
        </van-popup>
        <van-field v-model="userInfo.YjCity" placeholder="请选择市区" is-link readonly required input-align="right"
                   @click="userInfo.showYjCity = true" v-if="userInfo.YjCityShow" />
        <van-popup v-model="userInfo.showYjCity" position="bottom">
          <van-picker :columns="cityYjList" show-toolbar value-key="title" @cancel="userInfo.showYjCity = false"
                      @confirm="onConfirmYjCity" />
        </van-popup>
        <van-field v-model="userInfo.YjArea" placeholder="请选择区县" is-link readonly required input-align="right"
                   @click="userInfo.showYjArea = true" v-if="userInfo.YjAreaShow" />
        <van-popup v-model="userInfo.showYjArea" position="bottom">
          <van-picker :columns="areaYjList" show-toolbar value-key="title" @cancel="userInfo.showYjArea = false"
                      @confirm="onConfirmYjArea" />
        </van-popup>
        <van-field required label="邮寄详细地址" v-model="userInfo.Yjxxdz" placeholder="请输入邮寄详细地址" input-align="right" />
      </template>

<!--      <van-field label="申请查询开始时间:" placeholder="请选择" readonly  required is-link @click="openTime"-->
<!--        :value="userInfo.timeStart" />-->
<!--      <van-datetime-picker v-model="currentDate" type="date" v-if="userInfo.timeStartShow" :min-date="minDate" :max-date="maxDate" @confirm="handleTime"-->
<!--        @cancel="closeTime" />-->
<!---->
<!--      <van-field label="申请查询结束时间:" placeholder="请选择" readonly required is-link @click="openHour" :value="userInfo.timeEnd" />-->
<!--      <van-datetime-picker v-model="currentDate" type="date" v-if="userInfo.timeEndShow" :max-date="maxDate" @confirm="handleHour"-->
<!--        @cancel="closeHour" />-->
    </van-cell-group>
  </div>
</template>

<script>
import { Button, Toast, CellGroup, Field, Dialog, Popup, Picker, DatetimePicker, RadioGroup, Radio } from 'vant'
import { dateToString } from '@/utils/time'
import { baseApiMap } from '@/api/base'
import { idCardRegex, phoneRegex } from '@/utils/regex'
import { forEachObj } from '@/utils/check'

export default {
  components: {
    [Button.name]: Button,
    [Toast.name]: Toast,
    [CellGroup.name]: CellGroup,
    [Field.name]: Field,
    [Dialog.name]: Dialog,
    [Popup.name]: Popup,
    [Picker.name]: Picker,
    [DatetimePicker.name]: DatetimePicker,
    [RadioGroup.name]: RadioGroup,
    [Radio.name]: Radio
  },
  props: {
    applicationInfo: {
      type: Object,
      default: () => ({})
    },
  },
  data() {
    return {
      currentDate: new Date(),
      // minDate: new Date(1900,0,1),
      // maxDate: new Date(),
      provinceList: [], // 省
      cityList: [], // 市
      areaList: [], // 区县
      cityYjList: [], // 邮寄市
      areaYjList: [], // 邮寄区县
      columnsSex: [],// 性别集合
      userInfo: {
        xm: this.$cookie.getUser().realName,
        gmsfhm: this.$cookie.getUser().idNum.replace(/^(\d{3})\d{10}(\d+)/, '$1**********$2'),
        lxdh: this.$cookie.getUser().telephone,
        Sex: '', // 性别显示的名称
        Sexval: '', // 性别的值
        showPickerSex: false, // 性别
        CityShow: false, // 显示选择出生地市
        AreaShow: false, // 显示选择出生地区县
        showArea: false, // 是否显示籍贯区域选择框
        showProvince: false, // 是否显示籍贯省选择框
        showCity: false, // 是否显示出生地省选择框
        Province: '',//籍贯
        City: '', // 出生地市
        Area: '', // 出生地区县
        Areaval: '', // 出生地区县代码
        sqrsqsy: '',//申请理由
        lqfsTitle: '', // 领取方式
        lqfs: '',
        YjCityShow: false, // 显示邮寄市
        YjAreaShow: false, // 显示邮寄县
        showYjArea: false, // 是否显示邮寄籍贯区域选择框
        showYjProvince: false, // 是否显示邮寄籍贯省选择框
        showYjCity: false, // 是否显示邮寄省选择框
        YjProvince: '',//邮寄籍贯
        YjCity: '', // 邮寄市
        YjArea: '', // 邮寄县
        YjAreaval: '', // 邮寄县
        Yjxxdz: '', // 邮寄详细地址
        timeStart: '',//申请查询开始时间
        timeStartShow: false,//时间开始显示
        timeEnd: '',//申请查询结束时间
        timeEndShow: false,//时间结束显示
      },
      showPicker: false, // 领取方式
      columns: [{
        title: '邮件寄递',
        val: '1'
      }, {
        title: '电子文书',
        val: '2'
      }]
    }
  },
  mounted() {
    this.getProvinceData()
    this.getReservationSex()
  },
  methods: {
    /**
    * 控制开始时间 和结束时间
     */
    handleTime(value1) {
              // console.log(this.minData)
              // console.log(this.maxData)
      let year = this.currentDate.getFullYear();
      var tf = function (i) { return (i < 10 ? '0' : '') + i};
      let month = tf(this.currentDate.getMonth() + 1);
      let day = tf(this.currentDate.getDate());
      value1 = year + '-' + month + '-' + day
      this.userInfo.timeStart = value1
      this.userInfo.timeStartShow = false
    },
    closeTime() {
      this.userInfo.timeStartShow = false
    },
    openTime() {
      this.userInfo.timeStartShow = true
    },
    openHour() {
      this.userInfo.timeEndShow = true
    },
    handleHour(value2) {
      let year = this.currentDate.getFullYear();
      let month = this.currentDate.getMonth() + 1;
      let day = this.currentDate.getDate();
      // var tf = function (i) { return (i < 10 ? '0' : '') + i};
      // let month = tf(this.currentDate.getMonth() + 1);
      // let day = tf(this.currentDate.getDate());
      value2 = year + '-' + month + '-' + day
      this.userInfo.timeEnd = value2
      this.userInfo.timeEndShow = false
    },
    closeHour() {
      this.userInfo.timeEndShow = false
    },
    // 领取方式
    onConfirm(value) {
      this.userInfo.YjProvince = ''
      this.userInfo.YjCity = ''
      this.userInfo.YjArea = ''
      this.userInfo.YjAreaval = ''
      this.userInfo.YjCityShow = false
      this.userInfo.YjAreaShow = false
      this.userInfo.Yjxxdz = ''
      this.userInfo.lqfsTitle = value.title
      this.userInfo.lqfs = value.val
      this.showPicker = false

    },
    //获取性别
    getReservationSex() {
      this.$httpUtils.getCommonUtils(`${baseApiMap.dict}/dic.hz.xblb`).then(response => {
        let arr = [];
        if (response.data.succ = true) {
          var arrSex = response.data.data;
          for (var i = 0; i < arrSex.length; i++) {
            arr.push({ "title": arrSex[i].title, "val": arrSex[i].val })
          }
        }
        this.columnsSex = arr
      }).catch(err => {

      })
    },
    /**
    * 选择性别
    * @param value
    * @param index
    */
    onConfirmSex(value) {
      this.userInfo.Sex = value.title
      this.userInfo.Sexval = value.val
      this.userInfo.showPickerSex = false
    },
    /**
    *   出生省列表
    */
    onConfirmProvince(value, index) {
      this.userInfo.Province = value.title
      this.userInfo.showProvince = false
      this.userInfo.City = ''
      this.userInfo.Area = ''
      this.userInfo.CityShow = true
      this.getCityData(value.val)
    },
    /**
     *  市籍贯列表
     */
    onConfirmCity(value, index) {
      this.userInfo.City = value.title
      this.userInfo.Area = ''
      this.userInfo.showCity = false
      this.userInfo.AreaShow = true
      this.getAreaData(value.val)
    },
    /**
    *  出生区县列表
    */
    onConfirmArea(value) {
      this.userInfo.Area = value.title
      this.userInfo.Areaval = value.val
      this.userInfo.showArea = false
    },
    /**
    * 获取省
    */
    async getProvinceData() {
      try {
        const res = await this.$httpUtils.getCommonUtils(baseApiMap.registeredaArea + '/' + 0)
        let arr = [];
        if (res.data.succ = true) {
          let d = res.data.data
          for (var i = 0; i < d.length; i++) {
            arr.push({ "title": d[i].regionname, "val": d[i].regioncode })
          }
        }
        this.provinceList = arr
      } catch (error) {
        Toast('服务器运行失败')
        console.log(error);
      }
    },
    /**
     * 获取市
     */
    async getCityData(value) {
      try {
        this.cityList = []
        this.areaList = []
        const res = await this.$httpUtils.getCommonUtils(baseApiMap.registeredaArea + '/' + value);
        let arr = [];
        if (res.data.succ = true) {
          let d = res.data.data
          for (var i = 0; i < d.length; i++) {
            arr.push({ "title": d[i].regionname, "val": d[i].regioncode })
          }
        }
        this.cityList = arr
      } catch (error) {
        Toast('服务器运行失败');
        console.log(error);
      }
    },
    /**
     * 获取地区
     */
    async getAreaData(value) {
      try {
        this.areaList = []
        const res = await this.$httpUtils.getCommonUtils(baseApiMap.registeredaArea + '/' + value);
        let arr = [];
        if (res.data.succ = true) {
          let d = res.data.data
          for (var i = 0; i < d.length; i++) {
            arr.push({ "title": d[i].regionname, "val": d[i].regioncode })
          }
        }
        this.areaList = arr
      } catch (error) {
        Toast('服务器运行失败');
        console.log(error);
      }
    },
    /**
     * 获取地区
     */
    async getHJAreaData(value) {
      try {
        this.areaHJList = []
        const res = await this.$httpUtils.getCommonUtils(baseApiMap.registeredaArea + '/' + value);
        let arr = [];
        if (res.data.succ = true) {
          let d = res.data.data
          for (let i = 0; i < d.length; i++) {
            arr.push({ "title": d[i].regionname, "val": d[i].regioncode })
          }
        }
        this.areaHJList = arr
        if (this.areaHJList.length > 0) {
          this.HJAreaShow = true
        } else {
          this.HJAreaShow = false
        }
      } catch (error) {
        Toast('服务器运行失败');
        console.log(error);
      }
    },
    /**
     * 获取邮寄市
     */
    async getYjCityData(value) {
      try {
        this.cityYjList = []
        this.areaYjList = []
        const res = await this.$httpUtils.getCommonUtils(baseApiMap.registeredaArea + '/' + value);
        let arr = [];
        if (res.data.succ = true) {
          let d = res.data.data
          for (var i = 0; i < d.length; i++) {
            arr.push({ "title": d[i].regionname, "val": d[i].regioncode })
          }
        }
        this.cityYjList = arr
      } catch (error) {
        Toast('服务器运行失败');
        console.log(error);
      }
    },
    /**
     * 获取邮寄地区
     */
    async getYjAreaData(value) {
      try {
        this.areaYjList = []
        const res = await this.$httpUtils.getCommonUtils(baseApiMap.registeredaArea + '/' + value);
        let arr = [];
        if (res.data.succ = true) {
          let d = res.data.data
          for (var i = 0; i < d.length; i++) {
            arr.push({ "title": d[i].regionname, "val": d[i].regioncode })
          }
        }
        this.areaYjList = arr
      } catch (error) {
        Toast('服务器运行失败');
        console.log(error);
      }
    },
    /**
     *   邮寄省列表
     */
    onConfirmYjProvince(value, index) {
      this.userInfo.YjProvince = value.title
      this.userInfo.showYjProvince = false
      this.userInfo.YjCity = ''
      this.userInfo.YjArea = ''
      this.userInfo.YjCityShow = true
      this.getYjCityData(value.val)
    },
    /**
     *  邮寄市籍贯列表
     */
    onConfirmYjCity(value, index) {
      this.userInfo.YjCity = value.title
      this.userInfo.YjArea = ''
      this.userInfo.showYjCity = false
      this.userInfo.YjAreaShow = true
      this.getYjAreaData(value.val)
    },
    /**
     *  邮寄出生区县列表
     */
    onConfirmYjArea(value) {
      this.userInfo.YjArea = value.title
      this.userInfo.YjAreaval = value.val
      this.userInfo.showYjArea = false
    },
    /**
     * 校验数据
     */
    validApplicationPersonInfo1() {
      forEachObj(this.userInfo)
      if (!this.userInfo.xm) {
        Toast('请输入申请人姓名')
        this.$emit('getApplicationPersonInfo1', false)
        return
      }
      if (!this.userInfo.gmsfhm) {
        Toast('请输入公民身份证号')
        this.$emit('getApplicationPersonInfo1', false)
        return
      }
      if (!phoneRegex(this.userInfo.lxdh)) {
        Toast('请输入正确的联系电话')
        this.$emit('getApplicationPersonInfo1', false)
        return
      }
      if (!this.userInfo.Sex) {
        Toast('请选择性别')
        this.$emit('getApplicationPersonInfo1', false)
        return
      }

      if (!this.userInfo.Province||!this.userInfo.City||!this.userInfo.Area) {
        Toast('请选择户口所在地')
        this.$emit('getApplicationPersonInfo1', false)
        return
      }
      if (!this.userInfo.sqrsqsy) {
        Toast('请输入申请理由')
        this.$emit('getApplicationPersonInfo1', false)
        return
      }
      if (!this.userInfo.lqfs) {
        Toast('请选择领取方式')
        this.$emit('getApplicationPersonInfo1', false)
        return
      }
      if (this.userInfo.lqfs === '1' && (!this.userInfo.YjProvince||!this.userInfo.YjCity||!this.userInfo.YjArea)) {
        Toast('请选择邮寄地址')
        this.$emit('getApplicationPersonInfo1', false)
        return
      }
      if (this.userInfo.lqfs === '1' && !this.userInfo.Yjxxdz) {
        Toast('请输入邮寄详细地址')
        this.$emit('getApplicationPersonInfo1', false)
        return
      }

      // if (!this.userInfo.timeStart) {
      //   Toast('请选择申请查询开始时间')
      //   this.$emit('getApplicationPersonInfo1', false)
      //   return
      // }
      // if (!this.userInfo.timeEnd) {
      //   Toast('请选择申请查询结束时间')
      //   this.$emit('getApplicationPersonInfo1', false)
      //   return
      // }
      this.applicationInfo.xm = this.userInfo.xm
      this.applicationInfo.gmsfhm = this.$cookie.getUser().idNum
      this.applicationInfo.lxdh = this.userInfo.lxdh
      this.applicationInfo.Sex = this.userInfo.Sex
      this.applicationInfo.Sexval = this.userInfo.Sexval
      this.applicationInfo.Province = this.userInfo.Province
      this.applicationInfo.City = this.userInfo.City
      this.applicationInfo.Area = this.userInfo.Area
      this.applicationInfo.Areaval = this.userInfo.Areaval
      this.applicationInfo.sqrsqsy = this.userInfo.sqrsqsy
      this.applicationInfo.lqfsTitle = this.userInfo.lqfsTitle
      this.applicationInfo.YjAreaval = this.userInfo.YjAreaval
      this.applicationInfo.mailAddress = this.userInfo.YjProvince+this.userInfo.YjCity+this.userInfo.YjArea+this.userInfo.Yjxxdz
      // this.applicationInfo.timeStart = this.userInfo.timeStart
      // this.applicationInfo.timeEnd = this.userInfo.timeEnd
      this.$emit('getApplicationPersonInfo1', true)
      return
    }
  }
}
</script>

<style lang="less" scoped>
.title {
  padding: 0.3rem;
  color: #808080;
}
</style>
